var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAtcAirTrafficControlTower = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12 14.666H4.667v-3.333H12zM8.333 1.333a1 1 0 0 1 .334 1.942V4h4v.666h2V6h-.156l-.893 3.333h.049v1.333H3V9.333h.03L2.138 6H2V4.666h2V4h4v-.725a1 1 0 0 1 .333-1.942m-4.612 8h2.172L5.425 6H2.827zm2.845 0h3.535L10.569 6H6.098zm4.208 0h2.154L13.82 6h-2.579z"
})));
export default SvgAtcAirTrafficControlTower;